export type RemoteDropdownQuery = {
  pageIndex: number; // 1 based (UI)
  pageSize: number;
  search: string;
};

export type RemoteDropdownRequest = {
  pageNumber: number; // 1 based (API)
  pageSize: number;
  textFilter: string;
};

// Converts panel dropdown query (1-based) to backend dropdown request (1-based)
export function buildRemoteDropdownRequest(query: RemoteDropdownQuery): RemoteDropdownRequest {
  const dropdownPageIndex = query.pageIndex ?? 1;
  const apiPageNumber = Math.max(1, dropdownPageIndex);

  const apiPageSize = query.pageSize ?? 10;
  const textFilter = (query.search ?? '').trim();

  return {
    pageNumber: apiPageNumber,
    pageSize: apiPageSize,
    textFilter
  };
}

// Normalizes any drpdown-like backend resp
type DropdownResponse = {
  results?: any[];
  [key: string]: any;
};

export function normalizeDropdownState(
  response: DropdownResponse,
  dropdownPageIndex: number
) {
  return {
    ...response,
    results: response.results ?? [],
    pageIndex: dropdownPageIndex,
  };
}
